module.exports = __webpack_public_path__ + "assets/7b6d1dcbd9a6e2da35e3d8359baf66eb.png";